/**
 * Utilities to support AI operation polling + incremental refresh behavior.
 * Kept as pure functions to enable lightweight Jest tests.
 */

export const AI_ACTIVE_OPERATION_STATUSES = new Set(["pending", "executing"]);
export const AI_TERMINAL_OPERATION_STATUSES = new Set(["completed", "failed"]);

export function getHasActiveOperations(chat) {
  const messages = chat?.messages || [];
  return messages.some((msg) => {
    if (msg?.role !== "assistant") return false;
    const ops = msg?.operations || [];
    return ops.some((op) => AI_ACTIVE_OPERATION_STATUSES.has(op?.execution_status));
  });
}

export function getAssistantMessageIdsWithActiveOperations(chat) {
  const messages = chat?.messages || [];
  return messages
    .filter((msg) => msg?.role === "assistant")
    .filter((msg) => (msg?.operations || []).some((op) => AI_ACTIVE_OPERATION_STATUSES.has(op?.execution_status)))
    .map((msg) => msg.id);
}

export function getNewlyCompletedOperationReloadTargets(operations, completedOperationIds) {
  const reloadTargets = [];
  const newlyCompletedOperationIds = new Set();

  (operations || []).forEach((op) => {
    const opId = op?.id;
    if (!opId) return;

    const status = op?.execution_status;
    if (!AI_TERMINAL_OPERATION_STATUSES.has(status)) return;
    if (completedOperationIds?.has(opId)) return;

    newlyCompletedOperationIds.add(opId);

    const targets = Array.isArray(op?.reload_targets) ? op.reload_targets : [];
    targets.forEach((t) => {
      if (!t) return;
      if (!t.element_type || !t.element_id) return;
      reloadTargets.push({ element_type: t.element_type, element_id: t.element_id });
    });
  });

  return { newlyCompletedOperationIds, reloadTargets };
}

export function dedupeReloadTargets(targets) {
  const out = [];
  const seen = new Set();

  (targets || []).forEach((t) => {
    if (!t?.element_type || !t?.element_id) return;
    const key = `${t.element_type}:${t.element_id}`;
    if (seen.has(key)) return;
    seen.add(key);
    out.push(t);
  });

  return out;
}


